<template>
    <vue-final-modal
        v-bind="$attrs"
        v-slot="{ close }"
    >
        <div class="opui-modal">
            <div class="opui-modal-dialog" id="optpl-modal-quickstart">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>
                            {{ $e('OptimizePress Templates Library QuickStart Guide') }}
                        </h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <div style="padding:64.59% 0 0 0;position:relative;">
                            <iframe src="https://player.vimeo.com/video/917049367?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0"
                                allow="autoplay; fullscreen; picture-in-picture"
                                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                                title="Template Welcome Video">
                            </iframe>
                        </div>

                        <div class="opui-form-actions opui-justify-content-between opui-flex opui-pt-5">
                            <button type="button" class="opui-btn opui-btn-outline-secondary opui-px-6" style="margin-left: auto;" @click.prevent="close">{{ $e('Close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {

}
</script>

<style scoped>
#optpl-modal-quickstart {
    /*max-width: 1080px !important;*/
}
</style>
